import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/pages/articles/ArticlesNavigationContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FullArticlePreview"] */ "/app/app/components/pages/articles/FullArticlePreview/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/pages/articles/LimitedArticlePreview/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/box/box.js");
;
import(/* webpackMode: "eager", webpackExports: ["Heading"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/typography/heading.js");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/typography/text.js");
